export const PAYMENT_PROCESSING_DOWNLOAD = 'PAYMENT_PROCESSING_DOWNLOAD'
export const PAYMENT_PROCESSING_DOWNLOAD_PENDING = 'PAYMENT_PROCESSING_DOWNLOAD_PENDING'
export const PAYMENT_PROCESSING_DOWNLOAD_FULFILLED = 'PAYMENT_PROCESSING_DOWNLOAD_FULFILLED'
export const PAYMENT_PROCESSING_DOWNLOAD_REJECTED = 'PAYMENT_PROCESSING_DOWNLOAD_REJECTED'
